import React, {useState} from 'react'
import {FullscreenOutlined} from "@ant-design/icons";
import './stock.css'
import {getStockInformation} from "../../services/serviceInventory";
import {Button, Card, Modal, Table} from "antd";

const columns = [
    {
        title: 'Depo',
        dataIndex: 'warehouse',
        key: 'warehouse',
    },
    {
        title: 'Adet',
        dataIndex: 'quantity',
        key: 'quantity'
    }
]

const StockHandleWarehouse = ({stockId}) => {

    const [isModalVisible, setIsModalVisible] = useState(false)
    const [tableData, setTableData] = useState([])

    const handleWarehouse = () => {
        getStockInformation(stockId)
            .then(({data}) => {
                const stockInfos = data.map(item => {
                    return {
                        warehouse: `${item.warehouse.code} - ${item.warehouse.name}`,
                        quantity: item.quantity
                    }
                })
                setTableData(stockInfos)
            })
        setIsModalVisible(!isModalVisible)
    }

    return (
        <React.Fragment>
            <FullscreenOutlined className={'stock-warehouse-icon'} onClick={handleWarehouse}/>
            <Modal
                closable={false}
                open={isModalVisible}
                footer={[
                    <Button
                        type={"primary"}
                        onClick={() => setIsModalVisible(!isModalVisible)}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Card
                    title={'Stok Bilgisi'}
                >
                    <Table columns={columns} dataSource={tableData}/>
                </Card>
            </Modal>

        </React.Fragment>
    )
}
export default StockHandleWarehouse